import { PropsWithChildren } from 'react';

import styles from './modal.module.scss';

export default function ModalFooter({ children }: PropsWithChildren<{}>) {
  return <div className={styles.footer}>{children}</div>;
}
